export default "__VITE_ASSET__$Y8uPfNE__"